import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { fetchAddress } from '../actions';
import { selectWork } from '../../Api/selectors';
import { IDW_ADDRESSES, REQUEST_ADDRESS } from '../constants';
import { Loader } from '../../../components/Loader';
import { selectAddress } from '../selectors';
import { VBox } from '../../../components/Box';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WithAddressComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (!this.props.address) {
      this.props.fetch();
    }
  }

  render() {
    return this.props.busy ? <Loader small /> : this.props.children;
  }
}

WithAddressComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    busy: selectWork(`${REQUEST_ADDRESS}-addressId`),
    address: selectAddress(ownProps.addressId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      let isLocal = IDW_ADDRESSES.find(a => a.id == ownProps.addressId);
      if (isLocal) return;
      dispatch(fetchAddress(ownProps.addressId));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const WithAddress = compose(
  withConnect,
  withRouter,
)(WithAddressComp);
